import { ReactComponent as ChevronIcon } from 'assets/icons/chevron.svg';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { accountVaultsTitles } from 'config/constants';
import { planName } from 'helpers/plan-name';
import { classnames } from 'helpers/utils';
import { RouteName, goToPage } from 'routes';
import styles from './account-vaults-rows.module.scss';

type AccountVaultsRowsProps = {
  vaults: VaultType[];
  getVaultStatusLabel: Function;
  getRenewalExpiration: Function;
};

const AccountVaultsRows: React.FC<AccountVaultsRowsProps> = ({
  vaults,
  getVaultStatusLabel,
  getRenewalExpiration,
}) => {
  const getLastBilling = (vault: VaultType) =>
    vault.lastPayment?.amount
      ? `$${vault.lastPayment?.amount.toFixed(2)}`
      : '-';

  return (
    <div className={styles.vaultsRows}>
      <div className={styles.titles}>
        {Object.keys(accountVaultsTitles).map((title) => (
          <div
            key={title}
            className={classnames(
              styles[title],
              'text__body__semi__bold__medium__gray800',
            )}
          >
            {accountVaultsTitles[title]}
          </div>
        ))}
      </div>
      <div
        className={classnames(
          styles.body,
          'text__body__regular__medium__gray700',
        )}
      >
        {vaults.map((vault: VaultType) => (
          <div key={vault.id} className={styles.vaultRow}>
            <div className={styles.vaultName}>{vault.title}</div>

            <div className={classnames(styles.column, styles.subscription)}>
              {planName(vault)}
            </div>

            <div className={classnames(styles.column, styles.lastBilling)}>
              {getLastBilling(vault)}
            </div>

            <div
              className={classnames(styles.column, styles.renewalExpiration)}
            >
              {getRenewalExpiration(vault)}
              {getVaultStatusLabel(vault, styles.status)}
            </div>

            <div className={classnames(styles.column, styles.actions)}>
              <Button
                className={styles.detailsButton}
                buttonStyle={ButtonStyle.LinkColor}
                buttonSize={ButtonSize.Small}
                onClick={() => {
                  goToPage(RouteName.VaultSettings, { id: vault.id });
                }}
              >
                <span className={styles.noWrap}>Vault details</span>
                <span className={styles.chevronIcon}>
                  <ChevronIcon />
                </span>
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { AccountVaultsRows };
